package com.example.hukakmp.auth

/** Resultado del flujo nativo de Google Sign-In. */
data class GoogleSignInResult(
    val idToken: String? = null,
    val errorMessage: String? = null,
)

/**
 * Google queda disponible en Android mientras iOS usa correo + contraseña hasta que
 * incorporemos Sign in with Apple / Google nativo.
 */
expect val googleSignInAvailable: Boolean

expect class GoogleAuthProvider {
    suspend fun signIn(): GoogleSignInResult
}
